// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.breadcrumb-background {
  border-top: 1px solid #444343;
  width: 100%;
  height: 60px;
  background: linear-gradient(90deg, #0669B3 50%, white);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.6em 0 0 0;
}
.breadcrumb-background h6 {
  color: white;
  padding-left: 10px;
  font-weight: 500;
  font-size: 1.1em;
  margin-left: 12px;
}

.crumb-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

@media screen and (max-width: 927px) {
  .breadcrumb-background {
    height: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/BreadCrumb.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,6BAAA;EACA,WAAA;EACA,YAAA;EACA,sDAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;AAKJ;AAHI;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAKR;;AAFA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAKJ;;AAFA;EACI;IACI,YAAA;EAKN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
